import React from 'react';
import { observer } from '../../shared/observer';
import { runBusy, isBusy } from '../../shared/busy';

// Блок «Нужно тары: N шт.» + кнопка «Добавить тару».
// Видимость гейтится родителем (см. CartApp): здесь компонент рендерится
// только когда cart.need_coupled_count > 0. Аналог:
// client_app/src/screens/Cart/CartList/ShoppingCart/RecycledTare/index.tsx
class RecycledTareView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { busy: {}, error: null };
  }

  add = () => {
    this.setState({ error: null });
    runBusy(this, 'add', () => this.props.cart.addCoupled())
      .catch(() => this.setState({ error: 'Не удалось добавить тару' }));
  };

  render() {
    const cart = this.props.cart;
    const auth = this.props.auth;
    const need = cart.cart.need_coupled_count || 0;
    const tare = (auth.companyInfo.cart_coupled) || {};
    const txt = (tare.need_tare_txt || 'Нужно тары: {{need_coupled_count}}')
      .replace('{{need_coupled_count}}', need);
    const busy = isBusy(this, 'add');

    return (
      <div className="ng-recycled-tare">
        <p className="ng-recycled-tare__text">{txt}</p>
        <button
          type="button"
          className={'btn' + (busy ? ' is-busy' : '')}
          disabled={busy}
          onClick={this.add}
        >
          {tare.add_tare_btn_txt || 'Добавить тару'}
        </button>
        {this.state.error ? <div className="order-message">{this.state.error}</div> : null}
      </div>
    );
  }
}

export const RecycledTare = observer(RecycledTareView, ['cartStore', 'authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Cart/RecycledTare.jsx